import logo from '../Ressources/logo.PNG';

import Nav from './Nav';

import '../Styles/Header.css';
import { Link } from 'react-router-dom';

export default function Header(props) {
return (
    <header>
        <Link to="/"><img src={logo} alt="logo" className='logo' updatenav={props.updatenav}/></Link>
        <Nav routes = {props.routes} token={props.token} />
    </header>
);
}